import { blue, green, grey, orange, red } from '@mui/material/colors'

export const CRITICALITY_COLORS: Record<string, string> = {
  A: red[400],
  B: orange[400],
  C: green[400],
  Høy: red[400],
  Medium: orange[400],
  Lav: green[400],
}

export const CATEGORY_COLORS: Record<string, string> = {
  Kritisk: red[400],
  'Normalt - Høyt': orange[400],
  Standard: green[400],
  'Normalt - Lav': blue[400],
}

export function bucketColor(bucket: string): string {
  return CRITICALITY_COLORS[bucket] ?? CATEGORY_COLORS[bucket] ?? grey[400]
}

export const FLOW_CREATED_COLOR = blue[400]
export const FLOW_CLOSED_COLOR = green[400]

export const ALERT_WARN_COLOR = red[400]
export const OVERDUE_WARN_COLOR = orange[400]
